/**
 * Admin · Billing — placeholder (Phase 2 lands the Stripe integration).
 *
 * For early-access partners we manage billing in-person; this card is the
 * calm holding space until that flow is built.
 */
import { CreditCard, Mail } from "lucide-react";
import { AdminHeader } from "./_shared";

export default function AdminBilling() {
  return (
    <div data-testid="admin-billing-screen">
      <AdminHeader eyebrow="Billing" title="Coming next" />
      <section
        data-testid="admin-billing-placeholder"
        className="mt-8 rounded-3xl bg-white border hairline p-8 flex flex-col sm:flex-row gap-6 items-start"
      >
        <span
          className="h-14 w-14 rounded-2xl bg-[#F2EFEA] flex items-center justify-center shrink-0"
          aria-hidden
        >
          <CreditCard size={24} strokeWidth={1.6} className="text-[#1A1B2E]" />
        </span>
        <div>
          <h3 className="font-serif text-2xl text-[#171717]">
            We'll set up billing with you, in person.
          </h3>
          <p className="mt-3 text-base text-[#525252] max-w-xl">
            While Alouvya is in early access, our team handles invoicing
            directly so the experience stays calm and we can shape the pricing
            to your center's rhythm. Self-serve billing (with seat counts,
            invoicing, and Stripe) lands in the next iteration.
          </p>
          <a
            href="mailto:hello@alouvya.com"
            data-testid="admin-billing-contact"
            className="btn-primary mt-6 !py-2 !px-4 !text-xs"
          >
            <Mail size={12} strokeWidth={1.5} />
            hello@alouvya.com
          </a>
        </div>
      </section>
    </div>
  );
}
